export const Index = r => require.ensure([], () => r(require('./index')), 'profile-bundle');

export default [
  {
    path: 'profile',
    name: 'profile',
    component: Index
  }
];
